// 首页prepare接口数据校验
import {
  USER_FLAG,
} from '~/constants/new-credit'
import log from '~/utils/log'

type TProductInfo = {
  fundsChannelId: string
  productId: string
}

const COUNTRY = 'MX'

const CURRENCY = 'MXN'

const CURRENCYSYMBOL = 'MXN$'

const PAGE = 'homePage'

const PREPARE_DATA_ERROR_CODELIST = {
  productInfo: 1,
  country: 2,
  currencySymbol: 3,
  currency: 4,
  userFlag: 5,
  entryStatus: 6,
  hasUC: 7,
  page: 8,
  applyType: 9,
}

// 判空函数
const isEmpty = (val: string) => {
  return val === null || val === undefined || val === ''
}

// 非空字符串判断
const isNotEmptyStr = (val: string) => {
  return typeof val === 'string' && val !== ''
}

/**
 * 供应商信息校验函数
 * 错误后仅做上报 具体兜底处理在外层处理
 * @param val prepare接口返回的供应商信息
 * @returns {boolean} true-校验通过 false-校验失败
 */
const checkProductInfo = (val: TProductInfo) => {
  if (!val) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.productInfo,
      message: `供应商信息格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  if (!isNotEmptyStr(val.fundsChannelId)) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.productInfo,
      message: `供应商信息格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  if (!isNotEmptyStr(val.productId)) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.productInfo,
      message: `供应商信息格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

/**
 * 国家信息校验函数
 * @param val api下发的国家字段
 * @returns {boolean} true-校验通过 false-校验失败
 */
const checkCountry = (val: string) => {
  if (val !== COUNTRY) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.country,
      message: `国家信息格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

const checkCurrencySymbol = (val: string) => {
  if (val !== CURRENCYSYMBOL) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.currencySymbol,
      message: `货币单位格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

const checkCurrency = (val: string) => {
  if (val !== CURRENCY) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.currency,
      message: `货币格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

const checkUserFlag = (val: number) => {
  const whiteList = [
    USER_FLAG.ALL,
    USER_FLAG.DIDI,
    USER_FLAG.MINSAIT,
  ]
  if (!whiteList.includes(val)) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.userFlag,
      message: `用户来源格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

const checkHasUC = (val: boolean) => {
  if (val === false || val === true) return true
  log.error('check_prepare_data_err', {
    code: PREPARE_DATA_ERROR_CODELIST.hasUC,
    message: `是否UC用户格式错误: ${JSON.stringify(val)}`,
  })
  return false
}

const checkPage = (val: string) => {
  if (val !== PAGE) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.page,
      message: `page格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

const checkApplyType = (val: number) => {
  const regexp = /^[1-9]\d*$/g
  if (!regexp.test(val?.toString())) {
    log.error('check_prepare_data_err', {
      code: PREPARE_DATA_ERROR_CODELIST.applyType,
      message: `流程标识格式错误: ${JSON.stringify(val)}`,
    })
    return false
  }
  return true
}

export {
  checkProductInfo,
  checkCountry,
  checkCurrencySymbol,
  checkCurrency,
  checkUserFlag,
  checkHasUC,
  checkPage,
  checkApplyType,
}
